export default __webpack_public_path__ + "static/media/light.26426c37.png";